import { L } from '@lang';
import { Trans } from 'react-i18next';
import {
  IconAddSquare24,
  IconChevronDown24,
  IconMoreHorizontal24,
  IconShareExternal24,
} from '../../../../shared/icons';
import { AppInfo } from '../../../../widgets/AppInfo';
import { InstallStep, installStepBoldClassName } from '../../../../widgets/InstallStep';
import { NativeGlassCard } from '../../../../widgets/NativeGlassCard';
import { NativeSeparator } from '../../../../widgets/NativeSeparator';
import { VideoPreview } from '../VideoPreview';
import styles from './InstallCard.module.css';

export function InstallCard() {
  return (
    <NativeGlassCard>
      <AppInfo
        title={L.t('pwa_install_safari_native_video_app_title')}
        subtitle={L.t('pwa_install_safari_native_video_app_subtitle')}
      />
      <NativeSeparator />
      <p className={styles.description}>{L.t('pwa_install_safari_native_video_description')}</p>
      <NativeSeparator />
      <div className={styles.steps}>
        <InstallStep icon={<IconMoreHorizontal24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_native_video_menu_dots_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconShareExternal24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_native_video_share_button_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconChevronDown24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_native_video_show_more_button_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconAddSquare24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_safari_native_video_add_to_home_screen_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
      </div>
      <VideoPreview />
    </NativeGlassCard>
  );
}
